import { MenuTextMatch } from '@lexical/react/LexicalTypeaheadMenuPlugin';
import { AtSignMentionsRegexAliasRegex, AtSignMentionsRegex } from './constants';

function checkForAtSignMentions(
    text: string,
    minMatchLength: number,
): MenuTextMatch | null {
    let match = AtSignMentionsRegex.exec(text);

    if (match === null) {
        match = AtSignMentionsRegexAliasRegex.exec(text);
    }
    if (match !== null) {
        const maybeLeadingWhitespace = match[1];
        const matchingString = match[3];
        if (matchingString.length >= minMatchLength) {
            return {
                leadOffset: match.index + maybeLeadingWhitespace.length,
                matchingString,
                replaceableString: match[2],
            };
        }
    }
    return null;
}

export function getPossibleQueryMatch(text: string): MenuTextMatch | null {
    return checkForAtSignMentions(text, 1);
}
